import { css } from '@emotion/react'

export const regular = css`
  font-weight: 400;
`

export const medium = css`
  font-weight: 500;
`

export const heavy = css`
  font-weight: 700;
`
